import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface PermitRequirementData {
  is_required: boolean;
  permit_type?: string;
  township_name?: string;
  estimated_cost?: string;
  processing_time?: string;
  requirements?: string[];
  notes?: string;
}

export interface PermitRequirementResponse {
  success: boolean;
  data: PermitRequirementData | null;
  message?: string;
}

interface EnrichmentParams {
  query: string;
  service_type: string;
  location: string;
  requirements?: string;
}

export const useGetPermitRequirements = (
  params: EnrichmentParams,
  enabled = false
) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: ['permit-requirements', params.query, params.service_type, params.location],
    queryFn: async () =>
      handleApiCall<PermitRequirementResponse, EnrichmentParams>(
        session,
        'POST',
        'vendor/enrichments/permit-requirements',
        params
      ),
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
};
